import React from 'react';
import { Table } from 'react-bootstrap';
import axios from './../../constants/axios';
import { Link } from 'react-router';

class BrandHome extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         brands: [],
         filtered: []
      };
   }


   componentDidMount() {
      axios.get('brands')
         .then((res) => {
            this.setState({
               brands: res.data,
               filtered: res.data
            });
         });
   }

   filterOnName = (e) => {
      let searchString = e.target.value;
      this.setState({
         nameString: searchString
      });

      let filtered = this.state.brands.filter((c) => {
         return c.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
      });
      this.setState({
         filtered
      });
   };

   render() {
      const { filtered } = this.state;
      return (
         <Table striped bordered condensed hover >
            <thead>
            <tr>
               <th>Name</th>
               <th>Image</th>
               <th>Manufacturer</th>
               <th>Actions</th>
            </tr>
            <tr>
               <th>
                  <input className="form-control" type="text" value={this.state.nameString} onChange={this.filterOnName}
                         placeholder="Search By Name" />
               </th>
               <th>
                  &nbsp;
               </th>
               <th>
                  &nbsp;
               </th>
               <th>
                  &nbsp;
               </th>
            </tr>
            </thead>
            <tbody>

            {filtered.map((brand) => (
               <tr key={brand.id} >
                  <td>{brand.name}</td>
                  <td>{brand.image}</td>
                  <td>{brand.manufacturer_name}</td>
                  <td>
                     <Link to={`/brand/edit/${brand.id}`} >edit</Link>
                  </td>
               </tr>
            ))}
            </tbody>
         </Table>
      );
   }
}

export default BrandHome;



/** WEBPACK FOOTER **
 ** ./src/components/Brand/BrandHome.js
 **/